<template>
  <b-container fluid class="page__create-stack h-100">
    <b-row class="justify-content-center">
      <b-col xl="8" class="container-stack">
        <stack-editor
          ref="stackEditor"
          :is-deletable="true"
          :is-published="false"
          @submit:stack="onSubmit"
        />

        <b-col>
          <div class="button-container d-flex mb-u5">
            <b-button
              class="button__create-stack"
              variant="success"
              :disabled="isSubmitting"
              @click="submitForm"
            >
              <b-spinner v-if="isSubmitting" small></b-spinner>
              <span v-else> Create </span>
            </b-button>

            <base-back-to-previous-button
              class="btn__previous-page"
              variant="link"
              :disabled="false"
              @click="$router.push({ name: 'stacks' })"
            />
          </div>
        </b-col>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import StackEditor from './components/StackEditor.vue';
import BaseBackToPreviousButton from '@/components/base-components/BaseBackToPreviousButton.vue';

export default {
  components: {
    StackEditor,
    BaseBackToPreviousButton
  },
  data() {
    return {
      isSubmitting: false
    };
  },
  methods: {
    submitForm() {
      this.isSubmitting = true;
      this.$refs.stackEditor.submit();
    },
    async onSubmit(data) {
      if (data) {
        this.$router.push({ name: 'stack-managing' });
      }
      this.isSubmitting = false;
    }
  }
};
</script>

<style lang="scss">
.page__create-stack {
  padding: 0 20px;
  min-height: 100vh;

  .button-container {
    margin-top: 24px;
    justify-content: left;
  }
  .container-stack {
    max-width: 910px;
    padding: 0;
  }
}
</style>
